import { combineReducers } from 'redux';

import auth from './reducers/auth/reducer';
import user from './reducers/user/reducer';
import customizer from './reducers/customizer/';
import navbar from './reducers/navbar/Index';

export default combineReducers({ auth, user, customizer, navbar })